export const onDialogAddDoneItem = item => ({
  widget: 'models',
  type: 'onDialogAddDoneItem',
  payload: { item },
})



// WEBPACK FOOTER //
// ./src/models/actions/onDialogAddDoneItem.js